import React from 'react';

interface ParagliderIconProps {
  color?: string;
  size?: number;
}

const ParagliderIcon: React.FC<ParagliderIconProps> = ({ 
  color = '#FF6B6B', 
  size = 40
}) => {
  // Create unique IDs for this instance
  const gradientId = `wing-${color.replace('#', '')}-${Math.random().toString(36).substr(2, 9)}`;
  const maskId = `mask-${Math.random().toString(36).substr(2, 9)}`;
  
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.5))',
        transformOrigin: 'center'
      }}
    >
      <defs>
        {/* Gradient for wing */}
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor={color} stopOpacity="1" />
          <stop offset="100%" stopColor={color} stopOpacity="0.8" />
        </linearGradient>
        
        {/* Mask to show front half brighter */}
        <mask id={maskId}>
          <rect x="0" y="0" width="100" height="100" fill="white"/>
          <rect x="0" y="0" width="50" height="100" fill="gray" opacity="0.5"/>
        </mask>
      </defs>
      
      {/* Main paraglider wing shape */}
      <path
        d="M 50 25
           C 30 25, 10 30, 10 50
           C 10 60, 20 65, 30 67
           L 40 68
           L 50 69
           L 60 68
           L 70 67
           C 80 65, 90 60, 90 50
           C 90 30, 70 25, 50 25
           Z"
        fill={`url(#${gradientId})`}
        stroke={color}
        strokeWidth="1.5"
        strokeOpacity="0.8"
      />
      
      {/* Left half darker overlay for direction */}
      <path
        d="M 50 25
           C 30 25, 10 30, 10 50
           C 10 60, 20 65, 30 67
           L 40 68
           L 50 69
           L 50 25
           Z"
        fill="rgba(0,0,0,0.3)"
      />
      
      {/* Wing cells for depth */}
      <line x1="50" y1="30" x2="20" y2="60" stroke="rgba(0,0,0,0.2)" strokeWidth="1" />
      <line x1="50" y1="30" x2="30" y2="65" stroke="rgba(0,0,0,0.2)" strokeWidth="1" />
      <line x1="50" y1="30" x2="40" y2="67" stroke="rgba(0,0,0,0.2)" strokeWidth="1" />
      <line x1="50" y1="30" x2="60" y2="67" stroke="rgba(0,0,0,0.2)" strokeWidth="1" />
      <line x1="50" y1="30" x2="70" y2="65" stroke="rgba(0,0,0,0.2)" strokeWidth="1" />
      <line x1="50" y1="30" x2="80" y2="60" stroke="rgba(0,0,0,0.2)" strokeWidth="1" />
      
      {/* Pilot position indicator */}
      <circle cx="50" cy="55" r="3" fill="rgba(0,0,0,0.6)" />
    </svg>
  );
};

export default ParagliderIcon;